/* ================================================== */
/* CHECK BREAKPOINTS
/* ================================================== */

// Init
var breakpoint_lg;
var breakpoint_md;
var breakpoint_sm;
var breakpoint_xs;

// Check breakpoints
$(window).resize(function(){
	breakpoint_lg = $(window).width() >= 1440;
	breakpoint_md = $(window).width() >= 1092 && $(window).width() <= 1439;
	breakpoint_sm = $(window).width() >= 768 && $(window).width() <= 1091;
	breakpoint_xs = $(window).width() < 768;
}).resize();